module.exports = __webpack_public_path__ + "img/deskshelf19.828c4a9b.jpg";